// ---------------------------------------------------------------------------
// @noxverify/admin-web — app shell layout and navigation structure
// ---------------------------------------------------------------------------

/** Module layout areas in the admin backoffice */
export type AdminModule = 'platform' | 'tenant-admin' | 'analyst' | 'operations' | 'enterprise';

/** Navigation item for sidebar rendering */
export interface NavItem {
  label: string;
  path: string;
  module: AdminModule;
  permission: string;
}

/** Navigation structure organized by module */
export const ADMIN_NAV: NavItem[] = [
  // Platform module (NoxVerify operator views)
  { label: 'Tenants', path: '/platform/tenants', module: 'platform', permission: 'platform.tenants.read' },
  { label: 'Platform Members', path: '/platform/members', module: 'platform', permission: 'platform.members.manage' },
  { label: 'Support Sessions', path: '/platform/support-sessions', module: 'platform', permission: 'platform.support_sessions.read' },
  { label: 'Audit Events', path: '/platform/audit-events', module: 'platform', permission: 'platform.audit.read' },

  // Tenant Admin module (customer admin views)
  { label: 'Projects', path: '/tenant/projects', module: 'tenant-admin', permission: 'tenant.projects.read' },
  { label: 'Domains', path: '/tenant/domains', module: 'tenant-admin', permission: 'project.domains.read' },
  { label: 'Members', path: '/tenant/members', module: 'tenant-admin', permission: 'tenant.members.read' },
  { label: 'SSO', path: '/tenant/sso', module: 'tenant-admin', permission: 'tenant.sso.manage' },
  { label: 'Config Promotions', path: '/tenant/config', module: 'tenant-admin', permission: 'config.read' },
  { label: 'Cases', path: '/tenant/cases', module: 'tenant-admin', permission: 'case.read' },
  { label: 'Webhooks', path: '/tenant/webhooks', module: 'tenant-admin', permission: 'project.webhooks.manage' },

  // Analyst module (case review views)
  { label: 'Review Queue', path: '/analyst/queue', module: 'analyst', permission: 'review.assign' },

  // Operations module (monitoring and analytics)
  { label: 'Monitoring', path: '/operations/monitoring', module: 'operations', permission: 'platform.audit.read' },
  { label: 'Analytics', path: '/operations/analytics', module: 'operations', permission: 'platform.audit.read' },
  { label: 'Alerts', path: '/operations/alerts', module: 'operations', permission: 'platform.audit.read' },
  { label: 'AI Audit', path: '/operations/ai-audit', module: 'operations', permission: 'platform.audit.read' },

  // Enterprise module (governance and release management)
  { label: 'Runbooks', path: '/enterprise/runbooks', module: 'enterprise', permission: 'platform.deployment.manage' },
  { label: 'Data Governance', path: '/enterprise/data-governance', module: 'enterprise', permission: 'platform.deployment.manage' },
  { label: 'Releases', path: '/enterprise/releases', module: 'enterprise', permission: 'platform.deployment.manage' },
];

/** Filter nav items by module and available permissions. Wildcard '*' grants all. */
export function getVisibleNavItems(module: AdminModule, permissions: string[]): NavItem[] {
  const hasAll = permissions.includes('*');
  return ADMIN_NAV.filter(item => item.module === module && (hasAll || permissions.includes(item.permission)));
}
